import src from "IMAGE";
export default { src, width: 186, height: 55, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAOklEQVR42m3DsQ0AEBAAwC/EAL4QtUhUGo0FLKMSY+nFKj/B58f4Bb44wPMF92NLWJfA5zFdqt0US1N5vhS7yBQS+AAAAABJRU5ErkJggg=="};
